import { render, staticRenderFns } from "./PrintGroup.vue?vue&type=template&id=1c2121e0&scoped=true"
import script from "./PrintGroup.vue?vue&type=script&lang=js"
export * from "./PrintGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2121e0",
  null
  
)

export default component.exports